module.exports = __webpack_public_path__ + "static/img/page2-img2.b07d2a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/page2-img2.png
// module id = K2kN
// module chunks = 0